module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/ashley-colasantos-7031c42e6ccfa9268b59f46cd3aa0e05.jpg";